module.exports = __webpack_public_path__ + "img/gmo.f07f56e7.png";